"use client";

import { useEffect, useState } from "react";

const testimonials = [
  {
    name: "Arjun Singh",
    text: "Sourabh's teaching methodology is exceptional. He breaks down complex concepts into simple, understandable parts. His live problem-solving sessions changed the way I approach chemistry problems.",
    rating: 5,
  },
  {
    name: "Priya Verma",
    text: "The interactive classes are the best part. Dr. Kumar makes chemistry so engaging that I look forward to every session. His clarity on fundamentals is unmatched.",
    rating: 5,
  },
  {
    name: "Rohit Pandey",
    text: "From day one, I could see the difference in teaching quality. Sourabh's passion for chemistry and his patient explanations helped me overcome my fear of the subject.",
    rating: 5,
  },
  {
    name: "Anjali Mehta",
    text: "The best teacher I've learned chemistry from. Sourabh's doubt-solving sessions are incredibly helpful, and he explains each concept with such clarity and depth.",
    rating: 5,
  },
];

export default function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="testimonials" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-pretty">
            Student{" "}
            <span className="text-[var(--primary-color)]">Experience</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            What our students say about teaching approach
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl border-2 border-[var(--primary-color)] p-8 hover:shadow-lg hover:border-yellow-300 transition-all duration-300 ${
                isVisible ? "animate-fade-in-up" : "opacity-0"
              }`}
              style={{ animationDelay: isVisible ? `${index * 0.1}s` : "0s" }}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="text-yellow-500 text-xl">
                    ★
                  </span>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg italic">{`"${testimonial.text}"`}</p>
              <div>
                <p className="font-semibold text-blue-950">
                  {testimonial.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
